import React, { PureComponent } from "react";
import styled from "styled-components";
import { Row, Col, Card, Table } from "react-bootstrap";
import _ from 'lodash'
import { HideColumn } from './HideColumn'
import LayeredColumnChart from './LayeredColumnChart'
import get from 'lodash/get'

import { Loader } from './Loader'

class CompletedSanctioned extends PureComponent {
  state = {
    // excludeComponent:['AHP','ISSR','BLC','RAY'],
    excludeComponent: [2, 3, 1, 7, 11, 10, 12, 13,14],
    totaldata: '',
    totalisAllIndia: '',
    totalisState: '',
    totalisDist: '',
    totalstatesList: '',
    totaldistrictList: '',
    totalcityList: '',
    isLoading: true,
  };
  componentDidMount() {

    this.setState({
      isLoading: false,

    })
  }

  componentDidUpdate() {


    this.setState({
      isLoading: true,

    })
    this.setState({

      isLoading: false,

    })

  }

  render() {
    const {
      data = [],
      isAllIndia,
      isState,
      isDist,
      statesList = [],
      districtList = [],
      cityList = [],
      SchemesdataFilterType,
      propsisLoading
    } = this.props;

    const {
      excludeComponent,
      isLoading
    } = this.state

// console.log('SchemesdataFilterType---under-->>>>>>>>',SchemesdataFilterType);
    const grfData = SchemesdataFilterType === 'PMAYU' ? _.filter(data, f => excludeComponent.indexOf(_.get(f, 'comp_uniq_id')) !== -1 && (f.scheme_uniq_id === 3 || f.scheme_uniq_id === 2)) :
    SchemesdataFilterType === 'PMAYU2' ?  _.filter(data, f => excludeComponent.indexOf(_.get(f, 'comp_uniq_id')) !== -1 && f.scheme_uniq_id === 4):_.filter(data, f => excludeComponent.indexOf(_.get(f, 'comp_uniq_id')) !== -1)

    const calculateProgressGraphData = (type) => {
      const groupOrder = ["States", "Union Territories", "North East State"]
      const fnlGraphData = _.map(isAllIndia ? statesList : isState ? districtList : isDist ? cityList : [], (obj) => {
        const rowCode = isAllIndia ? _.get(obj, 'statecode') : isState ? _.get(obj, 'DistrictCode') : isDist ? _.get(obj, 'CityCode') : ''
        const rowName = isAllIndia ? _.get(obj, 'statename') : isState ? _.get(obj, 'DistrictName') : isDist ? _.get(obj, 'CityName') : ''

        const groupData = _.filter(grfData, f => isAllIndia ? _.get(f, 'StateCode') === rowCode : isState ? _.get(f, 'DistrictCode') === rowCode : isDist ? _.get(f, 'CityCode') === rowCode : false)
    

        const gSanctioned = _.sumBy(groupData, sm => Number(_.get(sm, 'HousesSanctionedEnahncement') || 0) + Number(_.get(sm, 'HousesSanctionedNew') || 0))
        const gGrounded = _.sumBy(groupData, sm => _.get(sm, 'totalWorkOrders') ? _.get(sm, 'totalWorkOrders') : 0)
        const gCompleted = _.sumBy(groupData, sm => _.get(sm, 'completed') ? _.get(sm, 'completed') : 0)
        const scoreGrounded = Math.round((gGrounded / gSanctioned) * 100) > 100 ? 100 : Math.round((gGrounded / gSanctioned) * 100)
        const scoreCompleted = Math.round((gCompleted / gSanctioned) * 100) > 100 ? 100 : Math.round((gCompleted / gSanctioned) * 100)
     

        if (isAllIndia) {
          return {
            "group": obj.NEState ? 'North East State' : obj.UT ? 'Union Territories' : 'States',
            "country": rowName,
            "Grounded": scoreGrounded,
            "Completed": scoreCompleted,
            "HousesSanctioned": 100,
            "GroundedValue": gGrounded,
            "SanctionValue": gSanctioned,
            "CompletedValue": gCompleted,

          }

        } else {
          return {
            "country": rowName,
            "Grounded": scoreGrounded,
            "Completed": scoreCompleted,
            "HousesSanctioned": 100,
            "GroundedValue": gGrounded,
            "SanctionValue": gSanctioned,
            "CompletedValue": gCompleted,

          }

        }

      });


      // console.log('fnlGraphData===>>>>>>>>>', fnlGraphData);
      return fnlGraphData.sort((a, b) => {
        return groupOrder.indexOf(a.group) - groupOrder.indexOf(b.group);
      });
    }

    ////////////////////************Grounding/Completion Vs Sanctioned Graph Data***********///////////////////////
    const sanctionedVsGrounded = calculateProgressGraphData('sanctionVsGrounded');
    //  SchemesdataFilterType==='PMAYU' ? isDist  ? _.filter(calculateProgressGraphData('ground'),f=>f.score > 0) : calculateProgressGraphData('ground') : SchemesdataFilterType==='PMAYU2' ? isDist ? _.filter(calculateProgressGraphData('ground'),f=>f.score > 0) : calculateProgressGraphData('ground') :'';
    

    if (isLoading) {
      return (
        <Loader />
      )
    }
    // if (propsisLoading === false && isLoading === false) {
      return (





        <Row
          className="printParent"
          style={{
            pageBreakAfter: "always",
            display: "flex",
            margin: 0,
            background: '#72e5be'
          }}
        >

{SchemesdataFilterType === 'both' ?
   <div class="row g-0 mb-3 gap-2">
        <div class="col" style={{ minWidth: "" }}>
        <fieldset className='border border-2 border-success p-0 mb-2 rounded-2' style={{ background: "#72e5be", height: '66px' }} >
        <legend className='float-none w-auto p-1' style={{ fontSize: 15, marginLeft: '20px', marginBottom:0 }} ><b>PMAY-U</b></legend>
    
            <div style={{ marginTop: "0px" }}>
              <HideColumn
                            columnList={[
                              { title: "AHP", key: 2 },
                              { title: "BLC", key: 3 },
                              { title: "ISSR", key: 1 },
                              { title: "RAY", key: 7 },
                             
                            ]}         
                name="NotDefault"
               schemeName={"PMAY-U"} 
              hideColumn={this.state.excludeComponent}
              getHideColumn={(excludeComponent) => this.setState({
                excludeComponent,
                isLoading: true
              })}
                          />



            </div>
          </fieldset>
        </div>

        <div class="col">
        <fieldset className='border border-2 border-success p-0 rounded-2' style={{ background: "#72e5be", height: "66px" }} >
        <legend className='float-none w-auto p-1' style={{ fontSize: 15, marginLeft: '20px' }} ><b>PMAY-U 2.0</b></legend>

            <div style={{ marginTop: "-10px" }}>
         <HideColumn
                            columnList={[
                              { title: "AHP", key: 11 },
                              { title: "BLC", key: 10 },
                              { title: "ARH", key: 12 },
          
                            ]}         
               name="NotDefault"
                schemeName={"PMAY-U 2.0"}
              hideColumn={this.state.excludeComponent}
              getHideColumn={(excludeComponent) => this.setState({
                excludeComponent,
                isLoading: true
              })}
                          />

            </div>
          </fieldset>
        </div>
      </div>  
:''
}



{(SchemesdataFilterType === 'PMAYU' || SchemesdataFilterType === 'PMAYU2')  ?
   <div class="row g-0 mb-3 gap-2">
        <div class="col" style={{ minWidth: "" }}>
        <fieldset className='border border-2 border-success p-0 mb-2 rounded-2' style={{ background: "#72e5be", height: '66px' }} >
        <legend className='float-none w-auto p-1' style={{ fontSize: 15, marginLeft: '20px', marginBottom:0 }} ><b>{SchemesdataFilterType === 'PMAYU' ? 'PMAY-U' : SchemesdataFilterType === 'PMAYU2'? 'PMAY-U 2.0' : ''}</b></legend>
    
            <div style={{ marginTop: "0px" }}>
              <HideColumn
                            columnList={SchemesdataFilterType === 'PMAYU' ? [
                              { title: "AHP", key: 2 },
                              { title: "BLC", key: 3 },
                              { title: "ISSR", key: 1 },
                              { title: "RAY", key: 7 },
                             
                            ] : SchemesdataFilterType === 'PMAYU2' ? [
                              { title: "AHP", key: 11 },
                              { title: "BLC", key: 10 },
                              { title: "ARH", key: 12 },
          
                            ] : ''}         
                name="NotDefault"
               schemeName={SchemesdataFilterType === 'PMAYU' ? 'PMAY-U' : SchemesdataFilterType === 'PMAYU2'? 'PMAY-U 2.0' : ''} 
              hideColumn={this.state.excludeComponent}
              getHideColumn={(excludeComponent) => this.setState({
                excludeComponent,
                isLoading: true
              })}
                          />



            </div>
          </fieldset>
        </div>

        
      </div> 
:''
}




{/*           
           {(SchemesdataFilterType === 'PMAYU' || SchemesdataFilterType === 'PMAYU2') ? 
                      <Row>
                                <Col md={12} sm={12} xs={12}>
                        <HideColumn
                            columnList={SchemesdataFilterType === 'PMAYU' ? [
                              { title: "AHP", key: 2 },
                              { title: "BLC", key: 3 },
                              { title: "ISSR", key: 1 },
                              { title: "RAY", key: 7 },
                              { title: "ARH", key: 14 },
                            ] : SchemesdataFilterType === 'PMAYU2' ? [
                              { title: "AHP", key: 11 },
                              { title: "BLC", key: 10 },
                              { title: "ARH", key: 12 },
          
                            ] : ''}         
               name="Show Component"
              hideColumn={this.state.excludeComponent}
              getHideColumn={(excludeComponent) => this.setState({
                excludeComponent,
                isLoading: true
              })}
                          />
               </Col>
                    </Row>
          :''} */}
          
                    {/* {SchemesdataFilterType === 'both' ?
                    <Row>
                      <Col md={6} sm={6} xs={6}>
                        <HideColumn
                            columnList={[
                              { title: "AHP", key: 2 },
                              { title: "BLC", key: 3 },
                              { title: "ISSR", key: 1 },
                              { title: "RAY", key: 7 },
                              { title: "ARH", key: 14 },
                            ]}
              name="PMAY-U"
              hideColumn={this.state.excludeComponent}
              getHideColumn={(excludeComponent) => this.setState({
                excludeComponent,
                isLoading: true
              })}
                          />
               </Col>
                  <Col md={6} sm={6} xs={6}>
                        <HideColumn
                            columnList={[
                              { title: "AHP", key: 11 },
                              { title: "BLC", key: 10 },
                              { title: "ARH", key: 12 },
          
                            ]}
                        
              name="PMAY-U 2.0"
              hideColumn={this.state.excludeComponent}
              getHideColumn={(excludeComponent) => this.setState({
                excludeComponent,
                isLoading: true
              })}
                          />
               </Col>
                    </Row>
                    :''} */}
          
          


          <div
            md={12}
            className="printChildSetup"
            style={{
              pageBreakAfter: "always",
              // width: "50%",
              // paddingRight: 15,
            }}
          >
            <Card>
              <Card.Body style={{ padding: 0 }}>
                {_.get(sanctionedVsGrounded, "length") ? (
                  <LayeredColumnChart
                    id={"LayeredColumnChart"}
                    data={sanctionedVsGrounded}

                  />
                ) : (
                  "Data not Found."
                )}
              </Card.Body>
            </Card>
          </div>
        </Row>
      )
    // }
  }
}

export default CompletedSanctioned;
